import ReactModal from 'react-modal';
import { useModal } from 'react-modal-hook';

import './styles/downloads.scss';
import CloseBtn from '../buttons/button-close';
import HubspotCalendar from 'components/forms/schedule-demo/steps/hubspot-calendar';

import './styles/custom-calendar.scss';

ReactModal.setAppElement('#___gatsby');

type ContentDownloadProps = {
    customCalendarUrl: string
    buttonModalLaunchText: string
    className?: string
}

const CustomCalendar = ({ 
  customCalendarUrl,
  buttonModalLaunchText,
  className
}:ContentDownloadProps) => {
  const [showModal, hideModal] = useModal(({ onExited }) => (
    <ReactModal
      isOpen
      onAfterClose={ onExited }
      onRequestClose={ hideModal }
      className="default-modal-wrapper custom-calendar-modal"
      overlayClassName="default-modal-overlay"
    >
      <section
        className="modal-inner-container"
        data-section="customCalendarModal"
      >
        <CloseBtn onClick={ hideModal } />
        <HubspotCalendar url={customCalendarUrl} />
      </section>
    </ReactModal>
  ));
  // eslint-disable-next-line
  return (
    <button className={`button is-rounded schedule-demo-button ${className && className} `} type="button" onClick={ showModal }>
      {buttonModalLaunchText}
    </button>
  );
};

export default CustomCalendar;
